import type { TableColumnConfig } from '@pct-ng/feature-table-material';
import { StatusCellComponent } from '../cell/status-cell/status-cell.component';

export function createStatusColumn<T>(i18nPrefix: string): TableColumnConfig<T> {
  return {
    id: 'status',
    field: 'status' as keyof T,
    label: `${i18nPrefix}STATUS`,
    cellContent: StatusCellComponent,
    sortable: false,
  };
}
